exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".card-footer[data-v-55c7932c]{text-align:right;font-size:14px;line-height:1.5}.flex-row-center[data-v-55c7932c]{display:flex;justify-content:center;align-items:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-55c7932c&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/OperationManage/SystemConfig/SystemConfig/Components/PhysicalReportCampusShield.vue
// module id = 535
// module chunks = 0